import styled from 'styled-components';
import { EyebrowStyles } from '../../shared/Eyebrow.styles';
import { spacing } from '../../../styles/newThemeVariables.styles';
import { ListStyles } from '../../shared/List.styles';

export const Title = styled.div`
  ${EyebrowStyles}
  color: ${({ theme }) => theme.textPrimary};
  margin-bottom: ${spacing.space16};
`;

export const Container = styled.div`
  ${ListStyles}
`;
